<script setup lang="ts">
  import { computed } from 'vue';
  import { useRealizationTime } from '@storefront/storefront';

  interface HasRealizationTime {
    realizationFrom: number | null;
    realizationTo: number | null;
  }

  interface Props {
    item: HasRealizationTime;
  }

  const props = defineProps<Props>();

  const realizationFrom = computed(() => props.item.realizationFrom);
  const realizationTo = computed(() => props.item.realizationTo);

  const realization = computed(() => useRealizationTime({
    realizationFrom: realizationFrom.value,
    realizationTo: realizationTo.value,
  }));
</script>
<template>
  <dl v-if="realization" class="product-realization-time">
    <dt class="product-realization-time__term">
      <SfIconRealizationTime aria-hidden="true" />
      {{ $t('SHOP.COMMON.LABEL.REALIZATION_TIME') }}
    </dt>
    <dd class="product-realization-time__details">
      {{ realization }}
    </dd>
  </dl>
</template>
<style>
  :root {
    --sf-product-realization-time-icon-color: var(--color-default);
    --sf-product-realization-time-icon-size: 0.875rem;
    --sf-product-realization-time-font-size: 0.75rem;
    --sf-product-realization-time-gap: 0.25rem;
  }
</style>
<style scoped lang="scss">
  .product-realization-time {
    display: flex;
    align-items: center;
    gap: var(--sf-product-realization-time-gap);
    flex-wrap: wrap;
    font-size: var(--sf-product-realization-time-font-size);

    &__term {
      display: inline-flex;
      align-items: center;
      gap: var(--sf-product-realization-time-gap);

      svg {
        color: var(--sf-product-realization-time-icon-color);
        font-size: var(--sf-product-realization-time-icon-size);
      }
    }

    &__details {
      font-weight: var(--font-weight-bold);
    }
  }

</style>
